import apiClient from './ApiClient';

export const getLeaveBalanceHistory = async (filter) => {
  try {
    const response = await apiClient.post('/api/LeaveBalanceHistory/get', filter);
    return response.data;
  } catch (error) {
    console.error('Error in getLeaveBalanceHistory:', error);
    throw error;
  }
};

export const saveLeaveBalanceHistory = async (data) => {
  try {
    const response = await apiClient.post('/api/LeaveBalanceHistory/save', data);
    return response.data;
  } catch (error) {
    console.error('Error in saveLeaveBalanceHistory:', error);
    throw error;
  }
}; 